<template>
  <div class="order-upload-drawer">
    <!-- 订单导入 -->
    <el-drawer
      title="录入"
      class="order-upload"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="orderUploadForm" :model="orderUploadForm" :rules="orderRules">
          <div class="tips">
            <img class="sign-blue" src="~assets/images/sigh/sigh-blue.png">
            <span class="tips-content">当发生订单缺失时，使用该功能补全数据</span>
            <span class="tips-text">（功能介绍）</span>
          </div>
          <el-form-item label="仓库名称" prop="warehouseId">
            <el-select 
              class="white"
              clearable
              v-model="orderUploadForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据来源" prop="dataSource">
            <el-select
              class="white"
              v-model="orderUploadForm.dataSource"
              placeholder="请选择数据来源"
            >
              <el-option
                v-for="item in dataSourceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下载导入模板">
            <div class="download-tmp" @click="downTmp">
              订单导入模板.xlsx
              <img class="upload-bottom" src="~assets/images/upload/upload-bottom.png">
            </div>
          </el-form-item>
          <el-form-item label="订单导入">
            <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
              <template slot="suffix">
                <el-upload
                  v-loading.fullscreen.lock="loading"
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :before-upload="uploadOrderExcel"
                >
                  <img class="upload-img" src="~assets/images/home/upload.png">
                </el-upload>
              </template>
            </el-input>
            <div v-else class="show-name">
              <span>{{ uploadFileName }}</span>
              <img @click="clearUploadFileName" src="~assets/images/close.png">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="orderUploadConfirm('orderUploadForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import OrderUpload from "models/page-head/order-upload";
import { downLoadFile } from "common/js/util";
export default {
  // drawer：订单导入开关；warehouseList：仓库集合
  props: ['drawer', 'warehouseList'],

  data() {
    return {
      orderUploadForm: {
        warehouseId: null,
        // 数据来源类型
        dataSource: 1
      },
      orderRules: {
        warehouseId: [
          { required: true, message: '请选择仓库名称', trigger: 'change' },
        ],
      },
      // 上传文件流
      formData: null,
      // 上传文件名称
      uploadFileName: '',
      loading: false,
      // 数据来源列表
      dataSourceList: [
        {
          id: 1,
          name: "WMS",
        },
        {
          id: 2,
          name: "易仓储",
        },
      ],
    }
  },

  created() {
  },

  methods: {
    /** 
     * @desc 关闭订单导入
    */
    handleCloseDrawer() {
      this.formData = null
      this.uploadFileName = ''
      this.$refs['orderUploadForm'].resetFields();
      this.$emit('closeParentDrawer')
    },

    /** 
     * @desc 导入订单
    */
    orderUploadConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = this.formData
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          if (formData.get('dataSource')) {
            formData.delete('dataSource')
          }
          formData.append("warehouseId", this.orderUploadForm.warehouseId);
          formData.append("dataSource", this.orderUploadForm.dataSource);
          OrderUpload.postWMSOrderExcel(formData).then(res => {
            if (res.success) {
              this.$message.success("导入成功");
              this.handleCloseDrawer()
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(res => {
            console.log(res);
            this.$message.error("导入失败");
          });
         }else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /** 
     * @desc 下载模板
    */
    downTmp() {
      let url
      let fileName
      if (this.orderUploadForm.dataSource == 1) {
        fileName = 'wms订单导入模板'
        url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/wms%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      } else {
        fileName = '闲林订单导入模板'
        url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E9%97%B2%E6%9E%97%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      }
      downLoadFile(fileName,url)
    },
    
    /** 
     * @desc 上传文件
    */
    uploadOrderExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      if (file) {
        this.loading = false
      }
      return false;
    },

    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      if (formData.get('file')) {
        formData.delete('file')
      }
    },
  }
}
</script>

<style lang='scss'>

</style>
